import React from 'react';
import {Pressable, SafeAreaView, View} from 'react-native';
import Text from '../../components/elements/Text';
import {tID} from '../../utils/TestIdHelper';
import CommonStyles from '../../utils/CommonStyles';
import Divider from '../../components/elements/Divider';
import makeStyles from './styles.web';
import {useTheme, useThemedStyles} from '../../theme';
import {BottomErrorDrawer, RequestSuccessPopup, RequestButton} from '.';
import {LeftArrowIcon} from '../../utils/SvgIcons';

const UI = ({
  children,
  navigation,
  fetchDate,
  modalVisible,
  bottomModalVisible,
  onPressMySetttings,
  employerName,
  firstName,
  lastName,
  email,
  requestEmployerId,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const navigateToLogin = () => navigation('/login', {replace: true});

  return (
    <SafeAreaView
      testID={tID('RequestUniqueId-SafeAreaView-Main')}
      style={styles.mainView}>
      <RequestSuccessPopup
        modalVisible={modalVisible}
        fetchDate={fetchDate}
        modalViewStyle={styles.modalView}
        textAlign="center"
      />
      <BottomErrorDrawer
        bottomModalVisible={bottomModalVisible}
        onPressMySetttings={onPressMySetttings}
        containerStyle={CommonStyles.justify_center}
        modalViewStyle={styles.bottomModalView}
        titleStyle={styles.bottomModalTitle}
        textAlign="center"
      />
      <Pressable
        testID={tID('RequestUniqueId-Pressable-SigninRouteLink')}
        style={styles.backPressable}
        onPress={navigateToLogin}>
        <LeftArrowIcon width={5} height={9} tintColor={colors.link} />
        <Text
          testID={tID('RequestUniqueId-Text-SigninRoute')}
          variation="Text1SemiBold"
          color={colors.link}
          lineHeight={21}
          style={CommonStyles.ml_12}>
          Back to Sign-In
        </Text>
      </Pressable>
      <Text
        testID={tID('RequestUniqueId-Text-Title')}
        variation="HeadlineBold28"
        color={colors.textPrimary}
        style={CommonStyles.mb_12}>
        Provide your details
      </Text>
      <Text
        testID={tID('RequestUniqueId-Text-SubTitle')}
        variation="Body1Regular"
        color={colors.textSecondary}
        style={CommonStyles.mb_22}>
        Send us your information and we’ll review to grant you access to the app
      </Text>
      <Divider />
      {children}
      <View style={[CommonStyles.mt_22, CommonStyles.mb_32]}>
        <Divider />
      </View>
      <RequestButton
        employerName={employerName}
        firstName={firstName}
        email={email}
        lastName={lastName}
        requestEmployerId={requestEmployerId}
        style={CommonStyles.max_width_292}
      />
    </SafeAreaView>
  );
};

export default UI;
